export const FIELD_INDEX = {
  HEADING_CONTENT: 0,
  WORDS_TO_COLOR: 1,
};

export const DEFAULT_COLOR = 'default';

export const COLOR_CLASS_MAP = {
  grey: 'heading--color-grey',
  pink: 'heading--color-pink',
  blue: 'heading--color-blue',
  indigo: 'heading--color-indigo',
  raspberry: 'heading--color-raspberry',
  red: 'heading--color-red',
  mango: 'heading--color-mango',
  green: 'heading--color-green',
  teal: 'heading--color-teal',
};
